/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Prop_P1_BeforeInputs */

const es_cap_prop_p1_before = /** @type {(inputs: Cap_Prop_P1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuando un armador necesita patrón para una reserva, recibes una propuesta con todo lo que importa: el barco, el puerto, la fecha, el tipo de salida y exactamente `)
};

const gl_cap_prop_p1_before = /** @type {(inputs: Cap_Prop_P1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cando un armador precisa patrón para unha reserva, recibes unha proposta con todo o que importa: o barco, o porto, a data, o tipo de saída e exactamente `)
};

const en_cap_prop_p1_before = /** @type {(inputs: Cap_Prop_P1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When an owner needs a skipper for a booking, you get a proposal with what matters: boat, port, date, trip type, and exactly `)
};

/**
* | output |
* | --- |
* | "When an owner needs a skipper for a booking, you get a proposal with what matters: boat, port, date, trip type, and exactly" |
*
* @param {Cap_Prop_P1_BeforeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_prop_p1_before = /** @type {((inputs?: Cap_Prop_P1_BeforeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Prop_P1_BeforeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_prop_p1_before(inputs)
	if (locale === "en") return en_cap_prop_p1_before(inputs)
	return es_cap_prop_p1_before(inputs)
});